
const API_URL = process.env.REACT_APP_API_URL;
export const getNewAccessToken = async () => {
    try {
        const response = await fetch(`${API_URL}/refresh-token`, {
            method: "POST",
            credentials: "include", // ✅ 쿠키 포함 (Refresh Token 사용)
        });
        if (response.status === 401) {
            console.warn("⛔ Refresh Token 만료됨. 로그아웃 처리...");
            sessionStorage.removeItem("accessToken"); // ✅ 자동 로그아웃
            window.location.reload();  // ✅ 로그인 페이지로 이동
            return null;
        }


        const data = await response.json();
        if (response.ok && data.accessToken) {
            sessionStorage.setItem("accessToken", data.accessToken);
            console.log("🔄 Access Token 갱신 성공!");
            return data.accessToken;
        } else {
            console.error("⛔ Access Token 갱신 실패:", data.detail);
            return null;
        }
    } catch (error) {
        console.error("⛔ Access Token 갱신 중 오류 발생:", error);
        return null;
    }
};

// export default SignInRefreshToken;
